/**
 * "이 기능은 앱에서" 안내 프롬프트 — appToast 와 동일한 구독형 스토어.
 *  AppOnlyModalHost 가 App 루트에서 렌더한다.
 *
 *  웹에서 네이티브 전용 기능을 누른 경우 nativeRoute.openNativeOrWeb() 이 호출한다.
 *  토스트로만 알리면 사용자가 다음에 뭘 해야 할지 알 수 없어서, 설치 유도까지 붙인 모달로 처리한다.
 */
let listeners = new Set();
let current = null;

export function subscribeAppOnly(fn) {
  listeners.add(fn);
  fn(current);
  return () => listeners.delete(fn);
}

export function showAppOnly(message) {
  current = { message, key: Date.now() };
  listeners.forEach((fn) => fn(current));
}

export function hideAppOnly() {
  current = null;
  listeners.forEach((fn) => fn(null));
}
